import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/bricks';

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: bold;
`;

export const items: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  ${getTypography(theme, TypographyName.BODY)}
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}

  &:first-of-type {
    margin-top: 0;
  }
`;
